import {getHoursMinutes} from '@hconnect/common/utils'
import {Box, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

type Props = {
  totalRunning?: string
  totalStopped?: string
}

export const EquipmentRunningTimesResultLegend: React.FC<Props> = ({
  totalRunning,
  totalStopped
}) => {
  const {t} = useTranslation(RUNNING_TIMES_WIDGET_NAMESPACE)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: '0.625rem'
      }}
    >
      {totalRunning && (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          display="flex"
          data-test-id="total-running-time"
        >
          {`${t('runningTime.legend.running')} ${getHoursMinutes(totalRunning)} h`}
        </Typography>
      )}
      {totalStopped && (
        <Typography
          variant="subtitle2"
          color="text.secondary"
          display="flex"
          data-test-id="total-stopped-time"
        >
          {`${t('runningTime.legend.stopped')} ${getHoursMinutes(totalStopped)} h`}
        </Typography>
      )}
    </Box>
  )
}
